










































import {
    SdsSidebar,
    SdsSidebarButton,
    SdsSidebarItem,
} from '@superbet-group/web.lib.ui-components';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';

import { RouteName } from '@app/router/constants/RouteName';

import { useFavourites } from './composition/useFavourites';
import { useSports } from './composition/useSports';

export default defineComponent({
    name: 'SdsSportsSidebar',
    setup() {
        const {
            pushRoute,
            router,
        } = useVueRouter();

        const stickyConfig = {
            scrollableContentSelector: '.sds-sports-sidebar__wrapper',
        };

        const { favouriteTournaments } = useFavourites();
        const {
            sports,
            allSportsId,
            selectedSportId,
            resolveSportLink,
            setSelectedSport,
        } = useSports();

        function showAllFavourites(tournamentId?: number) {
            pushRoute({
                name: RouteName.Sport.Favourites,
                query: {
                    tournamentId: tournamentId?.toString(),
                },
            });
        }

        function resolveFavouritesHref(tournamentId?: number) {
            return router.value.resolve({
                name: RouteName.Sport.Favourites,
                query: {
                    tournamentId: tournamentId?.toString(),
                },
            }).href;
        }

        function handleSportClick(event: Event, sportId: number) {
            event.preventDefault();
            event.stopImmediatePropagation();

            setSelectedSport(sportId);
        }

        return {
            sports,
            hasFavourites: computed(() => favouriteTournaments.value.length > 0),
            allSportsId,
            favouriteTournaments,
            selectedSportId,
            resolveSportLink,
            handleSportClick,
            showAllFavourites,
            resolveFavouritesHref,
            stickyConfig,
        };
    },
    components: {
        SdsSidebar,
        SdsSidebarItem,
        SdsSidebarButton,
    },
});
